import React, {useEffect, useMemo, useRef, useState} from 'react';
import {toast, ToastContainer} from "react-toastify";
import SideBar from "../../../common/SideBar";
import NavBar from "../../../common/NavBar";
import {Link} from "react-router-dom";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Tooltip} from 'primereact/tooltip';
import ReportsServices from "../../../services/ReportsServices";
import Spinner from "reactjs-simple-spinner";
import {Chart} from "primereact/chart";


const AccidentClaimsReport = (props) => {


    const [chartData, setChartData] = useState({
        labels: ['New', 'Validated','Authorized','Awaiting Payment','Paid','Suspended',
            'Rejected'
        ],
        datasets: [
            {
                data: [],
                backgroundColor: [
                    "#0832b9",
                    "rgba(77,229,191,0.78)",
                    "#FFA726",
                    "#ae2bb7",
                    'rgba(12,122,95,0.78)',
                    "#eae13d",
                    "#d20606",

                ],
                hoverBackgroundColor: [
                    "#1548ec",
                    "rgba(122,234,206,0.78)",
                    "#f6b24f",
                    "#e065e8",
                    'rgba(45,203,164,0.78)',
                    "#eae470",
                    "#ef4040",
                ]
            }
        ]
    });

    const [lightOptions] = useState({
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        }
    });

    const [stackedData, setStackedData] = useState({
        labels: [],
        datasets: [{
            type: 'bar',
            label: 'New',
            backgroundColor: '#6b4207',
            data: []
        }, {
            type: 'bar',
            label: 'Validated',
            backgroundColor: 'rgba(14,54,215,0.78)',
            data: []
        }, {
            type: 'bar',
            label: 'Authorized',
            backgroundColor: '#FFA726',
            data: []
        }, {
            type: 'bar',
            label: 'Awaiting Payment',
            backgroundColor: '#ae2bb7',
            data: []
        }, {
            type: 'bar',
            label: 'Paid',
            backgroundColor: 'rgba(0,114,86,0.78)',
            data: []
        }, {
            type: 'bar',
            label: 'Suspended',
            backgroundColor: '#eae13d',
            data: []
        },{
            type: 'bar',
            label: 'Rejected',
            backgroundColor: '#d20606',
            data: []
        },]
    });

    const getLightTheme = () => {

        let stackedOptions = {
            maintainAspectRatio: false,
            aspectRatio: .8,
            plugins: {
                tooltips: {
                    mode: 'index',
                    intersect: false
                },
                legend: {
                    labels: {
                        color: '#495057'
                    }
                }
            },
            scales: {
                x: {
                    stacked: true,
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                },
                y: {
                    stacked: true,
                    ticks: {
                        color: '#495057'
                    },
                    grid: {
                        color: '#ebedef'
                    }
                }
            }
        };

        return {
            stackedOptions
        }
    }

    const {stackedOptions} = getLightTheme();

    const AccidentClaimsColumns = useMemo(
        () => [
            {
                header: 'Policy Number',
                field: 'policy_number',
            },
            {
                header: 'Claimant Name',
                field: 'claimant_first_name',
            },
            {
                header: 'Claimant Surname',
                field: 'claimant_last_name',
            },
            {
                header: 'Relationship',
                field: 'relationship',
            },
            {
                header: 'Amount',
                field: 'amount_claimed',
            },
            {
                header: 'Reason',
                field: 'claim_reason',
            },
            {
                header: 'Claim Status',
                field: 'claim_status',
            },
            {
                header: 'Claim Type',
                field: 'claim_type',
            },
            {
                header: 'Created At',
                field: 'created_at',
            },
            {
                header: 'Initiated By',
                field: 'created_by',
            },
            {
                header: 'Updated At',
                field: 'updated_at',
            },
            {
                header: 'Modified By',
                field: 'updated_by',
            },
        ],
        []
    )
    const [data, setData] = useState([])
    const [selectedData, setSelectedData] = useState([])
    const dt = useRef(null);

    const exportColumns = AccidentClaimsColumns.map(col => ({title: col.header, dataKey: col.field}));

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({selectionOnly});
    }

    const exportPdf = () => {
        import('jspdf').then(jsPDF => {
            import('jspdf-autotable').then(() => {
                const doc = new jsPDF.default(0, 0);
                doc.autoTable(exportColumns, data);
                doc.save('accident_claims_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + '.pdf');
            })
        })
    }


    const exportExcel = () => {
        import('xlsx').then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(data);
            const workbook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
            const excelBuffer = xlsx.write(workbook, {bookType: 'xlsx', type: 'array'});
            saveAsExcelFile(excelBuffer, 'accident_claims_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear());
        });
    }

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then(module => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear() + EXCEL_EXTENSION);
            }
        });
    }


    const onSelectionChange = (e) => {
        setSelectedData(e.value);
    }

    const [request, setRequest] = useState({from: null, to: null})
    const [loading, setLoading] = useState(false);

    const handleOnChangeFrom = name => ({target: {value}}) => {
        console.log("from: ", value);
        setRequest({...request, [name]: value});
    }

    const handleOnChangeTo = name => ({target: {value}}) => {
        console.log("to: ", value);
        setRequest({...request, [name]: value});
    }

    const handleSubmit = () => {
        setLoading(true)
        if (request.from == '' || request.from == null || request.to == ''
            || request.to == null) {
            setLoading(false)
            toast.error('Select Valid Date Range', {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
            return
        }
        setChartData({
            labels: ['New', 'Validated','Authorized','Awaiting Payment','Paid','Suspended',
                'Rejected'
            ],
            datasets: [
                {
                    data: [],
                    backgroundColor: [
                        "#0832b9",
                        "rgba(77,229,191,0.78)",
                        "#FFA726",
                        "#ae2bb7",
                        'rgba(12,122,95,0.78)',
                        "#eae13d",
                        "#d20606",

                    ],
                    hoverBackgroundColor: [
                        "#1548ec",
                        "rgba(122,234,206,0.78)",
                        "#f6b24f",
                        "#e065e8",
                        'rgba(45,203,164,0.78)',
                        "#eae470",
                        "#ef4040",
                    ]
                }
            ]
        })
        // for (let i = 0; i < stackedData.datasets.length; i++){
        //     stackedData.datasets[i].data.length = 0
        // }
        for (let i = 0; i < stackedData.datasets.length; i++) {
            stackedData.datasets[i].data.push(0, 0, 0, 0, 0, 0, 0)
        }
        // console.log("request: ", request)
        // console.log("initial stacked data: ", stackedData)
        ReportsServices.accidentClaims(request)
            .then(res => {
                console.log("success: ", res);
                if (res.status === 200) {
                    setData(res.data.claims)
                    // pie chart data
                    setChartData({
                        labels: ['New', 'Validated', 'Authorized', 'Awaiting Payment', 'Paid', 'Suspended',
                            'Rejected'
                        ],
                        datasets: [
                            {
                                data: [res.data.new,res.data.validated,res.data.authorized,
                                res.data.awaiting_payment,res.data.paid,res.data.suspended,
                                    res.data.rejected],
                                backgroundColor: [
                                    "#0832b9",
                                    "rgba(77,229,191,0.78)",
                                    "#FFA726",
                                    "#ae2bb7",
                                    'rgba(12,122,95,0.78)',
                                    "#eae13d",
                                    "#d20606",

                                ],
                                hoverBackgroundColor: [
                                    "#1548ec",
                                    "rgba(122,234,206,0.78)",
                                    "#f6b24f",
                                    "#e065e8",
                                    'rgba(45,203,164,0.78)',
                                    "#eae470",
                                    "#ef4040",
                                ]
                            }
                        ]
                    })
                    // stacked labels config
                    let dat = []
                    res.data.dates.map((date, i) => {
                        dat.push(date.month + " " + date.year)
                    })
                    console.log("labels: ", dat)
                    stackedData.labels = dat;
                    // stacked data configs
                    dat.map((date, t) => {
                        console.log("started - and updated ", t);
                        //for each date, browse the stacks and update data accordingly

                        //loop through new data and update data[0] on the datasets object
                        if (res.data.stacked_data.length > 0) {
                            res.data.stacked_data.map((stack, i) => {
                                console.log("key: ", t, " stack: ", stack)
                                console.log('date: ', date, " month from db: ", stack.month, " is it true: ", date.startsWith(stack.month))
                                if (date.startsWith(stack.month)) {
                                    // stackedData.datasets[0].data.push(0,0,0,0,0,0,0)
                                    console.log("index: ", i, "records: ", stack.records)
                                    if (stack.claim_status === "NEW") {
                                        stackedData.datasets[0].data.splice(t, 1, stack.records)
                                        console.log("stack at position: ", t, " - ", stackedData.datasets[t].data);
                                    } else if (stack.claim_status === "VALIDATED") {
                                        stackedData.datasets[1].data.splice(t, 1, stack.records)
                                        console.log("stack at position: ", t, " - ", stackedData.datasets[t].data);
                                    } else if (stack.claim_status === "AUTHORISED") {
                                        stackedData.datasets[2].data.splice(t, 1, stack.records)
                                        console.log("stack at position: ", t, " - ", stackedData.datasets[t].data);
                                    } else if (stack.claim_status === "AWAITING_PAYMENT") {
                                        stackedData.datasets[3].data.splice(t, 1, stack.records)
                                        console.log("stack at position: ", t, " - ", stackedData.datasets[t].data);
                                    } else if (stack.claim_status === "PAID") {
                                        stackedData.datasets[4].data.splice(t, 1, stack.records)
                                        console.log("stack at position: ", t, " - ", stackedData.datasets[t].data);
                                    } else if (stack.claim_status === "SUSPENDED") {
                                        stackedData.datasets[5].data.splice(t, 1, stack.records)
                                    } else if (stack.claim_status === "REJECTED") {
                                        stackedData.datasets[6].data.splice(t, 1, stack.records)
                                    }

                                }
                            })
                        }
                    })

                    console.log("stacked data: ", stackedData)
                    setLoading(false)
                } else {
                    setData([])
                    setLoading(false)
                }
            }).catch(err => {
            console.log("error: ", err)
            setData([])
            setLoading(false)
        })
    }


    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        setLoading(false)
        setRequest({from: null, to: null, policy_number: null, policy_holder_id: null})
        setChartData({
            labels: ['New', 'Validated', 'Authorized', 'Awaiting Payment', 'Paid', 'Suspended',
                'Rejected'
            ],
            datasets: [
                {
                    data: [],
                    backgroundColor: [
                        "#0832b9",
                        "rgba(77,229,191,0.78)",
                        "#FFA726",
                        "#ae2bb7",
                        'rgba(12,122,95,0.78)',
                        "#eae13d",
                        "#d20606",

                    ],
                    hoverBackgroundColor: [
                        "#1548ec",
                        "rgba(122,234,206,0.78)",
                        "#f6b24f",
                        "#e065e8",
                        'rgba(45,203,164,0.78)',
                        "#eae470",
                        "#ef4040",
                    ]
                }
            ]
        })
        setStackedData({
            labels: [],
            datasets: [{
                type: 'bar',
                label: 'New',
                backgroundColor: '#0832b9',
                data: []
            }, {
                type: 'bar',
                label: 'Validated',
                backgroundColor: "rgba(77,229,191,0.78)",
                data: []
            }, {
                type: 'bar',
                label: 'Authorized',
                backgroundColor: '#FFA726',
                data: []
            }, {
                type: 'bar',
                label: 'Awaiting Payment',
                backgroundColor: '#ae2bb7',
                data: []
            }, {
                type: 'bar',
                label: 'Paid',
                backgroundColor: 'rgba(12,122,95,0.78)',
                data: []
            }, {
                type: 'bar',
                label: 'Suspended',
                backgroundColor: '#eae13d',
                data: []
            },{
                type: 'bar',
                label: 'Rejected',
                backgroundColor: '#d20606',
                data: []
            },]
        })
        console.log("refresh: ", stackedData.datasets)
        setData([])

    }, []);

    const header = (
        <div className="flex align-items-center export-buttons">
            <Button type="button" icon="pi pi-file" onClick={() => exportCSV(false)}
                    className="mr-2 p-button-secondary p-button-sm" data-pr-tooltip="CSV"/>
            <Button type="button" icon="pi pi-file-excel" onClick={exportExcel}
                    className="p-button-dark mr-2 p-button-sm" data-pr-tooltip="XLS"/>
            <Button type="button" icon="pi pi-file-pdf" onClick={exportPdf} className="p-button-danger mr-2 p-button-sm"
                    data-pr-tooltip="PDF"/>
            <Button type="button" icon="pi pi-filter" onClick={() => exportCSV(true)}
                    className="p-button-info ml-auto p-button-sm" data-pr-tooltip="Export Selection Only"/>
        </div>
    );

    // const footer = `In total there are ${data ? data.length : 0} commissions.`;

    /**
     *  Filter Modes
     */
        // PrimeReact.filterMatchModeOptions = {
        //     text: [
        //         FilterMatchMode.STARTS_WITH,
        //         FilterMatchMode.CONTAINS,
        //         FilterMatchMode.NOT_CONTAINS,
        //         FilterMatchMode.ENDS_WITH,
        //         FilterMatchMode.EQUALS,
        //         FilterMatchMode.NOT_EQUALS
        //     ],
        //     numeric: [
        //         FilterMatchMode.EQUALS,
        //         FilterMatchMode.NOT_EQUALS,
        //         FilterMatchMode.LESS_THAN,
        //         FilterMatchMode.LESS_THAN_OR_EQUAL_TO,
        //         FilterMatchMode.GREATER_THAN,
        //         FilterMatchMode.GREATER_THAN_OR_EQUAL_TO
        //     ],
        //     date: [
        //         FilterMatchMode.DATE_IS,
        //         FilterMatchMode.DATE_IS_NOT,
        //         FilterMatchMode.DATE_BEFORE,
        //         FilterMatchMode.DATE_AFTER
        //     ]
        // }


    const filters = {

            'policy_number': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'claim_status': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'claim_reason': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'claimant_first_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'claimant_last_name': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'created_at': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'claim_type': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'updated_at': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'created_by': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },
            'updated_by': {
                operator: FilterOperator.OR,
                constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS}]
            },

        }


    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <SideBar roles={JSON.parse(localStorage.getItem('roles'))}/>
            <div id="main-content" className="main-panel ps-container ps-theme-default">
                <NavBar roles={JSON.parse(localStorage.getItem('roles'))}/>
                <div className="content">
                    <div className="container-fluid">
                        <ul className="breadcrumb">
                            <Link to="/dashboard"><a href><i className="fa fa-home"/>&nbsp;Dashboard</a> </Link>
                            &nbsp;|&nbsp;
                            <Link to="/reports"><a href><i className="fa fa-folder-tree"/>&nbsp;Reports</a> </Link>
                            &nbsp;|&nbsp;
                            Accident Claims
                        </ul>
                        {loading && (
                            <div className="mr-5 ml-5 mt-5 mb-5 p-5">
                                <Spinner
                                    size="medium"
                                    message="Please wait....."
                                    line-fg-color="#64c3c2"
                                />
                            </div>

                        )}
                        {!loading && (
                            <>
                                <div className="row mt">

                                    <div className="col-lg-9">

                                        {/*    tabs*/}
                                        <div className="card">
                                            <h5 className="title h3 px-4">Accident Claims</h5>
                                            <div className="row px-4 container-fluid mt-2 mb-2">
                                                <div className="col-md-3">
                                                    <label htmlFor="">From:</label>
                                                    <input type="date" className="form-control"
                                                           onChange={handleOnChangeFrom('from')}/>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor="">To:</label>
                                                    <input type="date" className="form-control"
                                                           onChange={handleOnChangeTo('to')}/>
                                                </div>
                                                <div className="col-md-3">
                                                    <label htmlFor=""></label>
                                                    <button onClick={handleSubmit}
                                                            className="btn btn-primary btn-sm">Search
                                                    </button>
                                                </div>
                                            </div>
                                            <Tooltip target=".export-buttons>button" position="bottom"/>
                                            <DataTable value={data} responsiveLayout="scroll" header={header}
                                                       paginator
                                                       paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                                       rowsPerPageOptions={[10, 25, 50]}
                                                       currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                                       rows={10}
                                                       sortMode="multiple" filters={filters} filterDisplay="menu"
                                                       resizableColumns
                                                       ref={dt}
                                                       dataKey="id"
                                                       scrollable scrollHeight="700px"
                                                       selection={selectedData} onSelectionChange={onSelectionChange}
                                                       selectionMode="checkbox"
                                                       name={'accident_claims_' + new Date().getDate() + '_' + new Date().getMonth() + '_' + new Date().getFullYear()}
                                            >
                                                <Column selectionMode="multiple"/>
                                                <Column field="policy_number" header="Policy Number" filter
                                                        style={{minWidth: '12rem'}}></Column>
                                                <Column field="claimant_first_name" header="Claimant Name" filter
                                                        style={{minWidth: '12rem'}}></Column>
                                                <Column field="claimant_last_name" header="Claimant Last Name" filter
                                                        style={{minWidth: '14rem'}}></Column>
                                                <Column field="relationship" header="Relationship" filter
                                                        style={{minWidth: '14rem'}}></Column>
                                                <Column field="claim_status" style={{minWidth: '14rem'}}
                                                        header="Claim Status" filter
                                                        filterField="claim_status"
                                                ></Column>
                                                <Column field="claim_type" style={{minWidth: '14rem'}}
                                                        header="Claim Type" filter
                                                        filterField="claim_type"
                                                ></Column>
                                                <Column field="claim_reason" style={{minWidth: '12rem'}}
                                                        filter header="Claim Reason"></Column>
                                                <Column field="amount_claimed" style={{minWidth: '12rem'}}
                                                        header="Amount Claimed"></Column>
                                                <Column filter field="created_at" style={{minWidth: '12rem'}}
                                                        header="Created At"></Column>
                                                <Column filter field="created_by" style={{minWidth: '12rem'}}
                                                        header="Created By"></Column>
                                                <Column filter field="updated_at" style={{minWidth: '12rem'}}
                                                        header="Updated At"></Column>
                                                <Column filter field="updated_by" style={{minWidth: '9rem'}}
                                                        header="Updated By"></Column>
                                            </DataTable>
                                        </div>
                                        {/*    end tabs*/}
                                    </div>
                                    <div className="col-lg-3">
                                        {/*    tabs*/}
                                        <div className="card flex justify-content-center">
                                            <h5 className="h5 title p-3">Accident Claims Analysis as per Selected
                                                Dates</h5>
                                            <Chart type="pie" data={chartData} options={lightOptions}
                                                   style={{position: 'relative', width: '100%'}}/>
                                        </div>
                                        {/*    end tabs*/}
                                    </div>
                                </div>
                                <div className="row mt">

                                    <div className="col-lg-12">

                                        {/*    tabs*/}
                                        <div className="card flex justify-content-center">
                                            <h5 className="h5 title p-3">Monthly Accident Claims Analysis as per
                                                Selected Dates</h5>
                                            <Chart type="bar" data={stackedData} options={stackedOptions}/>
                                        </div>
                                        {/*    end tabs*/}
                                    </div>
                                </div>
                            </>

                        )}
                    </div>
                </div>
            </div>
        </>
    )

}

export default AccidentClaimsReport
